import React, {useState} from "react";
import MainPostContainer from "./Subpage/MainPostContainer";
import MainPostContainerSecond from "./Subpage/MainPostContainerSecond";
import "./Work.css";
function Work() {
  const [year, setYear] = useState("2025");

  const handleYearChange = (selectedYear) => {
    setYear(selectedYear);
  };  

  const baseStyles = {
    color: "blue",
  };

  return (
    <>
      <div className="container">
        <div
          className="container"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
          {/* Heading code start */}
          <div
            className="heading"
            style={{
              display: "flex",
              float: "left",
            }}>
            <h5 className="animate__animated animate__bounceInLeft" style={{color:"#ffffff",fontWeight:"bold"}}>
              Committee - Members!
            </h5>
          </div>
          {/* Heading code end */}

          {/* dropdown code start */}
          <div
            className="select-button"
            style={{
              display: "flex",
            }}>
            <button className="buttons animate__animated animate__bounceInRight">
              ▼ &nbsp; {year}
            </button>
            <div
              className="dropdown-content"
              style={{
                cursor: "pointer",
                textAlign: "center",
                backgroundColor:"#ffffff",
              }}>
              <button
                id="top"
                onClick={() => handleYearChange("2025")}
                style={{backgroundColor: "#ffffff", color: "#800000"}}>
                2025
              </button>
              <button
                id="top"
                onClick={() => handleYearChange("2024")}
                style={{backgroundColor: "#ffffff", color: "#800000"}}>
                2024
              </button>
              <button
                onClick={() => handleYearChange("2023")}
                style={{backgroundColor: "#ffffff", color: "#800000"}}>
                2023
              </button>
              <button
                id="bottom"
                onClick={() => handleYearChange("2022")}
                style={{backgroundColor: "#ffffff", color: "#800000"}}>
                2022
              </button>
            </div>
          </div>
          {/* dropdown code end */}
        </div>
        <MainPostContainer year={year} />
        <MainPostContainerSecond year={year} />
      </div>
    </>
  );
}

export default Work;
